import { MyRouterContext } from '@/App';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { BeforeLoadContext } from '@tanstack/react-router/dist/esm/route';

export const Route = createFileRoute('/_main/tenant/')({
  beforeLoad,
  component: () => <Outlet />,
});

async function beforeLoad({
  search,
}: BeforeLoadContext<{ project?: string }, Record<never, string>, MyRouterContext>) {
  throw redirect({ to: '/tenant/projects', search });
}
